import Button from '@atoms/Button/Button';
import Image from '@atoms/Image/Image';
import { IImage } from '@models/IImage';
import { ITabbedFeatureContent } from '@models/ITabbedFeatureContent';
import { IVideo } from '@models/IVideo';
import InViewVideo from '@molecules/InViewVideo/InViewVideo';
import classNames from 'classnames';

interface Props {
  readonly tab: ITabbedFeatureContent;
  readonly wideContent: boolean;
  readonly dataTestId: string;
}

const TabbedFeatureSlide = ({ tab, wideContent, dataTestId }: Props) => (
  <>
    <div
      className={classNames(
        'mb-5',
        wideContent ? 'aspect-square' : 'aspect-3/2'
      )}
    >
      {tab.media && 'url' in tab.media && tab.media.url ? (
        <InViewVideo
          video={tab.media as IVideo}
          videoClasses="[&>div>video]:object-cover h-full pointer-events-none"
          wrapperClasses="w-full h-full"
          autoPlay
          hasInVideoPlayButton
          controls={false}
          dataTestId={`${dataTestId}-Video`}
        />
      ) : (
        <Image
          image={tab.media as IImage}
          classes="h-full"
          imageClasses="w-full h-full object-cover"
          dataTestId={`${dataTestId}-Image`}
        />
      )}
    </div>

    {tab.title && (
      <p
        className="h6 font-light text-white"
        data-testid={`${dataTestId}-Title`}
      >
        {tab.title}
      </p>
    )}

    {tab.textNew && (
      <div
        className="body-three mt-2.5 text-grey-500"
        data-testid={`${dataTestId}-Text`}
        dangerouslySetInnerHTML={{ __html: tab.textNew }}
      />
    )}
    {tab.text && !tab.textNew && (
      <p
        className="body-three mt-2.5 text-grey-500"
        data-testid={`${dataTestId}-Text`}
      >
        {tab.text}
      </p>
    )}

    {tab.cta?.url && (
      <div className="mt-6 mb-1">
        <Button link={tab.cta} dataTestId={`${dataTestId}-CTA`}>
          {tab.cta?.name}
        </Button>
      </div>
    )}
  </>
);

export default TabbedFeatureSlide;
